const basePath = '/api/session'

export const useSession = () => {
  const { fetchPostForm, fetchGet, fetchPost } = useCustomFetch()

  async function signin(cardId: string, password: string): Promise<UaO> {
    const form = {
      id: `${cardId}`,
      password,
      'remember-me': true,
    }
    return await fetchPostForm(`${basePath}/signin`, form)
  }

  async function signout(): Promise<void> {
    await fetchPost(`${basePath}/signout`)
  }

  async function getUaO(): Promise<UaO> {
    return await fetchGet<UaO>(`${basePath}/uaa`)
  }

  const BASE_URL = '/api/user/'

  function getAccount(): Promise<{
    user: User
    email: string
    organizations: { [key: string]: Organization }
  }> {
    return fetchGet(BASE_URL + 'account')
  }

  function getUser(id: string): Promise<User> {
    return fetchGet(BASE_URL + 'get-by-id?id=' + id)
  }

  function registerUser(
    id: string,
    email: string,
    password: string,
    registerKey: string,
  ): Promise<JpsResponse> {
    return fetchPostForm(BASE_URL + 'register', {
      id,
      mail: email,
      password,
      registerKey,
    })
  }

  function startResetPassword(email: string): Promise<JpsResponse> {
    return fetchPostForm(BASE_URL + 'start-reset-password', { mail: email })
  }

  function finishResetPassword(
    password: string,
    token: string,
  ): Promise<JpsResponse> {
    return fetchPostForm(BASE_URL + 'finish-reset-password', {
      password,
      token,
    })
  }

  function updatePassword(oldPassword: string, newPassword: string) {
    return fetchPostForm(BASE_URL + 'update-password', {
      oldPassword,
      newPassword,
    })
  }

  function updateEmail(email: string) {
    const formData = new FormData()
    formData.append('email', email)
    return fetchPostForm(BASE_URL + 'update-email', { email })
  }

  function deleteUser(): Promise<JpsResponse> {
    return fetchPost(BASE_URL + 'delete-user')
  }

  function getUserByEmail(email: string): Promise<User> {
    return fetchPostForm(BASE_URL + 'get-user-by-email', { email })
  }

  async function uaoSwitch(orgId: string): Promise<UaO> {
    return await fetchPostForm(BASE_URL + 'uao-switch', { id: orgId })
  }

  return {
    signin,
    signout,
    getUaO,
    getAccount,
    getUser,
    registerUser,
    startResetPassword,
    finishResetPassword,
    updatePassword,
    updateEmail,
    deleteUser,
    getUserByEmail,
    uaoSwitch,
  }
}
